import { render, staticRenderFns } from "./UploadButtons.vue?vue&type=template&id=2a5a99b2"
import script from "./UploadButtons.vue?vue&type=script&lang=js"
export * from "./UploadButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports